<template>
  <div v-if="player">
    <!-- title -->
    <p class="title is-4 is-spaced">Player: {{ player.username }}</p>

    <!-- tabs -->
    <div class="tabs is-boxed">
      <ul>
        <router-link :to="{ name: 'player' }" active-class="is-active" tag="li" exact><a>General</a></router-link>
        <router-link :to="{ name: 'player-transactions' }" active-class="is-active" tag="li"><a>All transactions</a></router-link>
        <router-link :to="{ name: 'player-pins' }" active-class="is-active" tag="li"><a>Pins</a></router-link>
        <router-link :to="{ name: 'player-redpipe-bets' }" active-class="is-active" tag="li"><a>RedPipe bets</a></router-link>
        <router-link :to="{ name: 'player-flg-bets' }" active-class="is-active" tag="li"><a>FLG bets</a></router-link>
        <router-link :to="{ name: 'player-hdraces-bets' }" active-class="is-active" tag="li"><a>HdRaces bets</a></router-link>
        <router-link :to="{ name: 'player-bk-bets' }" active-class="is-active" tag="li"><a>BK bets</a></router-link>
        <router-link :to="{ name: 'player-tvbet-bets' }" active-class="is-active" tag="li"><a>TVBet bets</a></router-link>
        <router-link :to="{ name: 'player-covid-bets' }" active-class="is-active" tag="li"><a>COVID bets</a></router-link>
      </ul>
    </div>

    <router-view />
  </div>
</template>
<script>
  import state from '../../../../../state'
  import playerService from '../../../../../services/player.service'
  import breadcrumbsService from '../../../../../services/breadcrumbs.service'

  import description from '../../../../common/description.vue'

  export default {
    name: 'player',
    components: { description },
    computed: {
      playerId() {
        return this.$route.params.playerId;
      },
      player() {
        return state.editPlayer.get();
      }
    },
    async mounted() {
      await playerService.load(this.playerId);
      breadcrumbsService.dynamic.set({ key: "player", func: () => this.player.username });
    },
    beforeDestroy() {
      state.editPlayer.unset();
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/players/player/index.vue